import api from "./api";

// Employee Services
export const employeeService = {
  getAll: () => api.get("/employees"),
  getById: (id) => api.get(`/employees/${id}`),
  create: (data) => api.post("/employees", data),
  update: (id, data) => api.put(`/employees/${id}`, data),
  delete: (id) => api.delete(`/employees/${id}`),
  uploadPhoto: (id, formData) =>
    api.post(`/employees/${id}/photo`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
};

// Attendance Services
export const attendanceService = {
  getBiometricLogs: (params) => api.get("/attendance/logs", { params }),
  getByEmployee: (employeeId, params) =>
    api.get(`/attendance/${employeeId}`, { params }),
  getReport: (params) => api.get("/attendance/report", { params }),
  manualEntry: (data) => api.post("/attendance/manual", data),
};

// Leave Services
export const leaveService = {
  request: (data) => api.post("/leave/request", data),
  update: (id, data) => api.put(`/leave/${id}`, data),
  getMyRequests: (employeeId) =>
    api.get("/leave/my-requests", { params: { employeeId } }),
  getPending: () => api.get("/leave/pending"),
  approve: (id) => api.put(`/leave/${id}/approve`),
  reject: (id, reason) => api.put(`/leave/${id}/reject`, { reason }),
};

// Department Services
export const departmentService = {
  getAll: () => api.get("/departments"),
  create: (data) => api.post("/departments", data),
  update: (id, data) => api.put(`/departments/${id}`, data),
  delete: (id) => api.delete(`/departments/${id}`),
};

// Holiday Services
export const holidayService = {
  getAll: () => api.get("/holidays"),
  create: (data) => api.post("/holidays", data),
  update: (id, data) => api.put(`/holidays/${id}`, data),
  delete: (id) => api.delete(`/holidays/${id}`),
};

// Dashboard Services
export const dashboardService = {
  getStats: () => api.get("/dashboard/stats"),
  getRecentActivity: () => api.get("/dashboard/activity"),
};

export const salarySlipService = {
  getEmployeesMeta: () => api.get("/salary-slips/employees"),
  list: (params) => api.get("/salary-slips", { params }),
  get: (id) => api.get(`/salary-slips/${id}`),
  create: (data) => api.post("/salary-slips", data),
  update: (id, data) => api.put(`/salary-slips/${id}`, data),
  remove: (id) => api.delete(`/salary-slips/${id}`),
  downloadPdf: (id) =>
    api.get(`/salary-slips/${id}/pdf`, {
      responseType: "blob",
      params: { _t: Date.now() }, // Cache busting
      headers: {
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0",
      },
    }),
  exportExcel: (params) =>
    api.get("/salary-slips/export", {
      params,
      responseType: "blob",
    }),
};

export const payrollService = {
  sendSalarySlips: (data) => api.post("/payroll/send-salary-slip", data),
};

// File download (presigned URLs for S3 - fixes Access Denied on direct S3 links)
export const fileService = {
  getDownloadUrl: (fileUrl) =>
    api.get("/files/download", { params: { url: fileUrl } }),
  openDownload: async (fileUrl, onError) => {
    if (!fileUrl) return;
    const isS3Url = fileUrl.includes(".s3.") && fileUrl.includes("amazonaws.com");
    if (!isS3Url) {
      window.open(fileUrl, "_blank");
      return;
    }
    try {
      const res = await api.get("/files/download", { params: { url: fileUrl } });
      const url = res.data?.url || res.data;
      if (url) window.open(url, "_blank");
      else if (onError) onError("No download URL returned");
    } catch (err) {
      if (onError) onError(err.response?.data?.error || err.message || "Download failed");
    }
  },
};

// Expense Services
export const expenseService = {
  request: (data) => api.post("/expenses/request", data),
  update: (id, data) => api.put(`/expenses/${id}`, data),
  uploadReceipt: (formData) => api.post("/expenses/upload-receipt", formData),
  getMyRequests: (params) => api.get("/expenses/my-requests", { params }),
  getPending: (params) => api.get("/expenses/pending", { params }),
  approve: (id) => api.put(`/expenses/${id}/approve`),
  reject: (id, reason) => api.put(`/expenses/${id}/reject`, { reason }),
};

export default {
  employee: employeeService,
  attendance: attendanceService,
  leave: leaveService,
  department: departmentService,
  holiday: holidayService,
  dashboard: dashboardService,
  salarySlip: salarySlipService,
  payroll: payrollService,
  file: fileService,
};
